module.exports = "<div class=\"c-auth c-auth--error\"> <div class=c-auth__inner> <div class=c-auth__content> <div class=\"c-auth__header u-fade-in\"> <logo-words></logo-words> </div> <div class=c-auth__message> <spinner large=true></spinner> <h2>Loading...</h2> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/auth/views/loading.html
// module id = 584
// module chunks = 0